export enum InputType {
  'checkbox' = 'checkbox',
  'radio' = 'radio',
}

export interface Data {
  valueCheckbox: boolean
}
